export default __webpack_public_path__ + "static/media/Untitled-1.c7b85db3.png";